import React, {useContext} from 'react';
import {ModalContext} from '../../../context-providers/ModalProvider';
import {observer} from 'mobx-react';
import StakeDialog from '../../modals/StakeDialog/StakeDialog';
import './StakeButtons.scss';
import NereusButton from '../../NereusButton/NereusButton';
import {useSwitchChainToPolygon} from "../../../hooks/useSwitchChainToPolygon";
import StakeWithdrawDialog from "../../modals/StakeWithdrawDialog/StakeWithdrawDialog";
import { ReactComponent as WalletIcon } from '../../../assets/icons/wallet.svg';
import {contractAddresses} from "../../../helpers/config/contracts.config";
import {ContractContext} from "../../../context-providers/ContractsProvider";

const StakeButtons: any = observer(() => {
    const { openModal } = useContext(ModalContext);

    const { veNrsContract } = useContext(ContractContext);
    const switchChainToPolygon = useSwitchChainToPolygon();

    const handleOpenStakeModal = async () => {
        try {
            await switchChainToPolygon()
            openModal(<StakeDialog/>)
        } catch (err) {
            console.error("Stake error", err)
        }
    };
    const handleOpenWithdrawModal = async () => {
        try {
            await switchChainToPolygon()
            openModal(<StakeWithdrawDialog/>)
        } catch (err) {
            console.error("Withdraw error", err)
        }
    };
    const handleImportTokenModal = async () => {
        try {
            await window.ethereum.request({
                method: "wallet_watchAsset",
                params: {
                    type: "ERC20",
                    options: {
                        address: contractAddresses.polygon.veNrs,
                        symbol: await veNrsContract.read.symbol(),
                        decimals: 18,
                        image: `${window.location.origin}/assets/crypto-icons/nrs.svg`,
                    },
                },
            });
        } catch (err) {
            console.error("handleImportTokenModal error", err)
        }
    };

    return (
        <div className="StakeButtons">
            <div className="flex gap-4">
                <NereusButton className="flex-1" variant="contained" onClick={handleOpenStakeModal}>
                    Stake
                </NereusButton>
                <NereusButton style={{minWidth: '165px'}} className="flex-1" variant="outlined" color="secondary" onClick={handleOpenWithdrawModal}>
                    Request&nbsp;Withdrawal
                </NereusButton>
                <NereusButton style={{maxWidth: '36.5px', minWidth: '36.5px', padding: 0}} variant="outlined" color="secondary" onClick={handleImportTokenModal}>
                    <WalletIcon/>
                </NereusButton>
            </div>
        </div>
    );
});

export default StakeButtons;
